<template>
  <div>
  <b-tabs >
    <b-tab title="Aktionen" @click="activateTab('action')">
      <b-card>
        <luma-actions-vserver></luma-actions-vserver>
      </b-card>
    </b-tab>

    <b-tab class="stats" title="Status" @click="activateTab('status')">
      <b-card  >
        <luma-status-vserver :vid="vid"
                             :loadPage="tabsC.status.value"
                             :activated="tabsC.status.activated">
        </luma-status-vserver>
      </b-card>
    </b-tab>

    <b-tab title="Backups" @click="activateTab('backups')">
      <b-card>
          <luma-backups-vserver :loadPage="tabsC.backups.value"></luma-backups-vserver>
      </b-card>
    </b-tab>
    <b-tab title="Netzwerke" @click="activateTab('networks')">
      <b-card>
        <luma-network-vserver :loadPage="tabsC.networks.value"></luma-network-vserver>
      </b-card>
    </b-tab>
    <b-tab title="Geplante Aufgaben" @click="activateTab('scheduled')">
      <b-card >
        <luma-scheduled-tasks-vserver :loadPage="tabsC.scheduled.value"></luma-scheduled-tasks-vserver>
      </b-card>
    </b-tab>
    <b-tab title="IP Adressen" @click="activateTab('ipaddresses')">
      <b-card>
        <luma-ip-adresses-vserver :loadPage="tabsC.ipaddresses.value"></luma-ip-adresses-vserver>
      </b-card>
    </b-tab>
    <b-tab title="Tasks" @click="activateTab('tasks')">
      <b-card>
        <luma-tasks-vserver :loadPage="tabsC.tasks.value"></luma-tasks-vserver>
      </b-card>
    </b-tab>
    <b-tab title="Konsole">
      <b-card>
        <luma-console-vserver></luma-console-vserver>
      </b-card>
    </b-tab>
    <b-tab title="Management">
      <b-card>
        <luma-managemnt-vserver></luma-managemnt-vserver>
      </b-card>
    </b-tab>
  </b-tabs>
  </div>
</template>

<script>

    import LumaStatusVserver from "./luma-status-vserver";
    import LumaActionsVserver from "./luma-actions-vserver";
    import LumaBackupsVserver from "./luma-backups-vserver";
    import LumaConsoleVserver from "./luma-console-vserver";
    import LumaNetworkVserver from "./luma-network-vserver";
    import LumaTasksVserver from "./luma-tasks-vserver";
    import LumaIpAdressesVserver from "./luma-ip-adresses-vserver";
    import LumaScheduledTasksVserver from "./luma-scheduled-tasks-vserver";
    import LumaManagemntVserver from "./luma-managemnt-vserver";
    export default {
        name: "luma-tabs-vserver",
      components: {
          LumaManagemntVserver,
          LumaScheduledTasksVserver,
          LumaIpAdressesVserver,
          LumaTasksVserver,
          LumaNetworkVserver,
          LumaConsoleVserver,
          LumaBackupsVserver,
          LumaActionsVserver,
          LumaStatusVserver
      },
        data:()=>({
            tabs:{
                action:{
                    value:false
                },
                backups:{
                    value:false
                },
                networks:{
                    value:false
                },
                status:{
                    activated:false,
                    value:false
                },
                ipaddresses:{
                  value:false
                },
                tasks:{
                  value:false
                },
                scheduled:{
                  value:false
                },
                management:{
                    value:false
                }
            }
        }),
      computed: {
        vid(){
          return this.$route.params.id
        },
        tabsC(){
            return this.tabs
        }
      },
        methods:{
            async activateTab(tabname){
                tabname === 'status' ? this.tabs[tabname].activated = true : this.tabs['status'].activated = false
                this.tabs[tabname].value = true
                const x = await setTimeout('',1000)
                this.tabs[tabname].value = false
                console.log("ACTIVATE TAB:::", tabname)
            }
        }
    }

</script>

<style scoped>
  div{
    border: none;
  }

  .nav-item{
    border:none;
  }


</style>



// WEBPACK FOOTER //
// src/components/datacenter/vserver_datacenter/luma-tabs-vserver.vue